import { useTranslation } from 'react-i18next';
import { numberToLocale } from 'utils/translate';

export default function SidebarAmountMTP({
  amount,
  mtp,
  isError,
  drawerOpen = false,
}: {
  amount?: number;
  mtp?: number;
  isError?: boolean;
  drawerOpen?: boolean;
}) {
  const { t } = useTranslation(['common', 'calculator']);
  return (
    <div className="flex lg:flex-col lg:w-full" data-test="amount-wrapper">
      {drawerOpen ? (
        <div className="font-bold">{t('edit_amount')}</div>
      ) : (
        <>
          <div
            data-test="amount"
            className="pr-3 border-r lg:pr-0 lg:border-r-0 lg:pb-3"
          >
            <div className="text-xs text-muted" data-test="amount-header">
              {t('loan')}
            </div>

            {amount ?? isError ? (
              <div className="flex gap-1 items-baseline">
                <span
                  className="text-xl font-extrabold lg:text-2xl"
                  data-test="amount-value"
                >
                  {amount ? numberToLocale(amount) : '-'}
                </span>
                <span className="text-xs" data-test="amount-currency">
                  {t('currency')}
                </span>
              </div>
            ) : (
              <div className="animate-pulse bg-background-accent h-8 w-24" />
            )}
          </div>

          <div data-test="mtp" className="pl-3 lg:pl-0">
            <div className="text-xs text-muted" data-test="mtp-header">
              {t('calculator:offer.mtp')}
            </div>
            {mtp ?? isError ? (
              <div className="flex gap-1 items-baseline">
                <span className="text-xl font-extrabold" data-test="mtp-value">
                  {mtp ? numberToLocale(mtp) : '-'}
                </span>
                <span className="text-xs" data-test="mtp-currency">
                  {t('currency')}
                </span>
              </div>
            ) : (
              <div className="animate-pulse bg-background-accent h-7 w-16" />
            )}
          </div>
        </>
      )}
    </div>
  );
}
